import styles from 'partials/timeline.module.scss';

export const TimelineCluster = ({ title }) => {
	return <div className={styles.cluster}>{title}</div>;
};
